import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import { apiRequest } from '../services/apiService';

interface DocumentUploaderProps {
  relatedToId: string;
  relatedToType: string;
}

const DocumentUploader: React.FC<DocumentUploaderProps> = ({
  relatedToId,
  relatedToType
}) => {
  const [documentType, setDocumentType] = useState<string>('');
  const [uploading, setUploading] = useState<boolean>(false);

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      if (!documentType) {
        alert('Please enter a document type before uploading.');
        return;
      }

      const file = acceptedFiles[0];
      const formData = new FormData();
      formData.append('file', file);
      formData.append('related_to_id', relatedToId);
      formData.append('related_to_type', relatedToType);
      formData.append('document_type', documentType);

      try {
        setUploading(true);
        // const res = await axios.post('/api/crm/documents/upload', formData, {
        //   headers: { 'Content-Type': 'multipart/form-data' }
        // });
        const res = await apiRequest(
          '/crm/documents/upload',
          'POST',
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );

        alert('Upload successful!');
      } catch (error) {
        console.error(error);
        alert('Upload failed');
      } finally {
        setUploading(false);
      }
    },
    [relatedToId, relatedToType, documentType]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div>
      <label>
        Document Type:
        <input
          type="text"
          value={documentType}
          onChange={e => setDocumentType(e.target.value)}
          placeholder="e.g. Proposal, Contract"
          className="form-control mb-3"
        />
      </label>

      <div
        {...getRootProps()}
        style={{
          border: '2px dashed #ccc',
          padding: '20px',
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: isDragActive ? '#f0f0f0' : '#fff'
        }}
      >
        <input {...getInputProps()} />
        {uploading ? (
          <p>Uploading...</p>
        ) : isDragActive ? (
          <p>Drop the file here...</p>
        ) : (
          <p>Drag & drop a file here, or click to select a file</p>
        )}
      </div>
    </div>
  );
};

export default DocumentUploader;
